var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDineInTakeOut = function SvgDineInTakeOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7A42A0",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.46674,
    d: "M18.667 14.667a2.667 2.667 0 0 1-5.333 0M10.069 12.023h11.863"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.46674,
    d: "M10.267 11.645a1.33 1.33 0 0 0-.267.8v8.889a1.333 1.333 0 0 0 1.333 1.333h9.334a1.333 1.333 0 0 0 1.334-1.333v-8.89a1.33 1.33 0 0 0-.267-.8l-1.333-1.777a1.33 1.33 0 0 0-1.067-.534h-6.667a1.33 1.33 0 0 0-1.067.534z"
  }))));
};
export default SvgDineInTakeOut;